module.exports = __webpack_public_path__ + "assets/img/bgres.75a90a23.jpg";